module.exports = __webpack_public_path__ + "img/smt.1b2d9990.png";